import $ from 'jquery';
$(document).ready(function () {
  heroSliderBlock();
});
function heroSliderBlock() {
  $('.nav-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '.prev',
    nextArrow: '.next',
    dots: false,
    infinite: true,
    focusOnSelect: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
}
